import React, { useState, useEffect } from 'react';
import { IoListSharp, IoSearch, IoAddCircleOutline } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { HTTP } from '../../api/http-common';
import ErrorHandlingComponent from '../../components/ErrorHandlingComponent';
import 'sweetalert2/dist/sweetalert2.min.css';
import Loader from '../../components/loader';
import Pagination from '../../components/pagination';
import HeroPosterListUI from '../../components/HeroPosterListUI';
import useUserRoleEffect from '../../components/userRoleEffect';
import { CommonTitle } from '../../components/commonComponents';

export default function HeroPoster() {
    const access_token = (localStorage.getItem('access_token'));
    const userObj = (JSON.parse(localStorage.getItem('userObj')));
    const [error, setError] = useState(null);
    const [rerenderFlag, setRerenderFlag] = useState(false);
    const [heroPosters, setHeroPosters] = useState([]);
    const [search, setSearch] = useState({ title: '', is_active: null });
    const [sorting, setSorting] = useState({ field: 'id', type: 'desc' });
    const [total, setTotal] = useState(0);
    const [pagination, setPagination] = useState({ page: '1', limit: '10' });
    const [isLoading, setIsLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('')

    const userRole = userObj?.role?.id;
    useUserRoleEffect(userRole);

    const loadHeroPosters = async () => {
        setIsLoading(true)
        let config = {
            headers: { 'Content-Type': 'application/json', 'token': access_token },
        }
        let fields = {
            filters: {
                title: search.title,
                is_active: search.is_active,
            },
            pagination: pagination,
            sorting: sorting,
        };
        HTTP.post('hero_poster/list', fields, config)
            .then((response) => {
                const data = response.data;
                if (response.status === 200) {
                    setHeroPosters(data.contents);
                    setTotal(data.total_count);
                }
                if (response.status === 204) {
                    setHeroPosters([])
                }
            })
            .catch((error) => {
                setError(error)
                setRerenderFlag(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };
    useEffect(() => {
        loadHeroPosters();
        if (rerenderFlag) {
            setRerenderFlag(false);
        }
    }, [rerenderFlag, search, pagination]);

    const onPaginationChange = (page) => {
        setPagination({ ...pagination, page });
    };

    const onLimitChange = (e) => {
        const newLimit = parseInt(e.target.value);
        setPagination({ ...pagination, limit: newLimit, page: 1 });
    };

    const handleSortFieldChange = (field) => {
        const newSorting = {
            field,
            type: 'desc',
        };
        setSorting(newSorting);
        setPagination({ ...pagination, page: 1, limit: (pagination.limit) });
    }

    const handleSortTypeChange = (type) => {
        setSorting({ ...sorting, type: type });
        setPagination({ ...pagination, page: 1, limit: pagination.limit });
    }

    const onSearchEnter = (value) => {
        if (value.length == 0 || value.length >= 3) {
            setSearch({ ...search, title: value });
            setPagination({ ...pagination, page: 1, limit: (pagination.limit) });
        }
    };

    if (isLoading) {
        return <Loader />;
    }

    return (
        <div className="article-wrapper">
            {rerenderFlag && <ErrorHandlingComponent err={error} />}
            {/* <h2 style={{ fontSize: '25px' }}>Hero Poster</h2> */}
            <CommonTitle PageTitle='Hero Poster' />
            <div className="video-table-wrapper">
                <div className="action-buttons-wrapper row">
                    <div className="left-button col-lg-6 col-md-3 col-6">
                        <button className="video-table-button-structure bg-secondary" style={{ padding: '7px 25px' }}>
                            <span>
                                <span className='video-page-icons'> <IoListSharp /></span>
                                <span>List </span>
                            </span>
                        </button>
                    </div>
                    <div className="right-button col-lg-6 col-md-9 col-6">
                        <ul className="action-buttons">
                            <Link to='/heroposter/add'>
                                <button className="video-table-button-structure bg-blue" style={{ padding: '7px 25px' }}>
                                    <span className='video-page-icons'>
                                        <IoAddCircleOutline />
                                    </span>
                                    <span>
                                        Add
                                    </span>
                                </button>
                            </Link>
                        </ul>
                    </div>
                </div>
                <div className="video-table-main">
                    <div className="timeline-actions-wrapper row justify-content-between align-items-center">
                        <div className="col-xl-5 col-lg-5 col-md-7">
                            <span className="d-block border border-secondary p-1 border-radius">
                                <span><IoSearch /></span>
                                <span>
                                    <input type='text' placeholder='Search and press Enter' className='border-0 inner-searchbar' value={searchValue} onChange={(e) => setSearchValue(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { onSearchEnter(e.target.value) } }} />
                                </span>
                            </span>
                        </div>
                        <div className='col-xl-4 col-lg-5 col-md-6 d-flex align-items-center video-table-dropdown p-0'>
                            <span>
                                <label htmlFor="sort" className='pe-2'> Sort:</label>
                                <select className="border-secondary  p-1  form-input" value={sorting.field} onChange={(e) => handleSortFieldChange(e.target.value)}>
                                    <option value="id">Id</option>
                                    <option value="title">Title</option>
                                    <option value="description">Description</option>
                                    <option value="created_at">Created At</option>
                                    <option value="updated_at">Updated At</option>
                                </select>
                            </span>
                            <span>
                                <label htmlFor="sortBy" className='pe-2'> SortBy:</label>
                                <select className="border-secondary  p-1  form-input" value={sorting.type} onChange={(e) => handleSortTypeChange(e.target.value)}>
                                    <option value="desc">Desc</option>
                                    <option value="asc">Asc</option>
                                </select>
                            </span>
                        </div>
                    </div>
                    <div>
                        {Array.isArray(heroPosters) && heroPosters.length > 0 ? (
                            heroPosters.map((heroPoster) => (
                                <HeroPosterListUI key={heroPoster.id} heroPoster={heroPoster} />
                            ))
                        ) : (
                            <p className='text-center mt-4'>
                                No hero poster found
                            </p>
                        )}
                    </div>
                </div>
                <>
                    {Array.isArray(heroPosters) && heroPosters.length > 0 ? (
                        <Pagination total={total} pagination={pagination} handlePageChange={onPaginationChange} handleLimitChange={onLimitChange} />
                    ) : (
                        null
                    )}
                </>
            </div>
        </div>
    )
}